import Card from './Card.jsx';
import { finite, number } from '../utils/format.js';

/**
 * @param {{label:string, value:string, delta?:number, deltaLabel?:string, meta?:string, hero?:boolean}} props
 */
export default function StatCard({ label, value, delta, deltaLabel, meta, hero = false }) {
  const numericDelta = Number(delta);
  const displayDelta = finite(delta) ? numericDelta.toFixed(2) : null;
  const deltaClass = numericDelta > 0 ? 'aq-stat-delta--gain' : numericDelta < 0 ? 'aq-stat-delta--loss' : '';
  return (
    <Card hero={hero}>
      <div className="aq-stat">
        <span className="aq-stat-label">{label}</span>
        <span className="aq-stat-value num">{typeof value === 'number' ? number(value) : value ?? '—'}</span>
        {displayDelta !== null && (
          <span
            className={`aq-stat-delta num ${deltaClass}`}
            aria-label={`${numericDelta > 0 ? 'Up' : numericDelta < 0 ? 'Down' : 'Unchanged'} ${Math.abs(numericDelta).toFixed(2)} percent`}
          >
            {numericDelta > 0 ? '▲ +' : numericDelta < 0 ? '▼ ' : '— '}
            {displayDelta}% {deltaLabel || ''}
          </span>
        )}
        {meta && <span className="aq-stat-meta">{meta}</span>}
      </div>
    </Card>
  );
}
